import { render, staticRenderFns } from "./attendance-gallery.vue?vue&type=template&id=65907d93&scoped=true&"
import script from "./attendance-gallery.vue?vue&type=script&lang=js&"
export * from "./attendance-gallery.vue?vue&type=script&lang=js&"
import style0 from "./attendance-gallery.vue?vue&type=style&index=0&id=65907d93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65907d93",
  null
  
)

export default component.exports